import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ListarArquivosPage } from './listar-arquivos.page';

const routes: Routes = [
  {
    path: '',
    component: ListarArquivosPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ListarArquivosPageRoutingModule {}
